/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';

import {
  Checkbox, Container, Header, Items,
} from './styles';

import useDebounce from '../../../../core/hooks/use-debounce';

const DEBOUNCE_TIME = 500;

const checkboxOptions = [
  { label: 'Unmoderated - Speak aloud', value: 'unmoderated' },
  { label: 'Moderated interview - Live conversation', value: 'moderated' },
  { label: 'Card sort', value: 'card_sort' },
  { label: 'Tree test', value: 'tree_test' },
  { label: 'Survey', value: 'survey' },
];

const Sidebar = ({ onSelection }) => {
  const [selected, setSelected] = React.useState(checkboxOptions.map(({ value }) => value));
  const [debouncedSearch] = useDebounce(() => selected, DEBOUNCE_TIME, [selected]);

  React.useEffect(() => {
    if (debouncedSearch) onSelection(debouncedSearch);
  }, [debouncedSearch]);

  const handleChange = (data, { value }) => {
    if (selected.includes(value)) {
      setSelected(selected.filter((each) => each !== value));
    } else {
      setSelected([...selected, value]);
    }
  };

  return (
    <Container>
      <Header as="h4">Type of study</Header>
      <Items>
        {checkboxOptions.map(({ label, value }) => (
          <Checkbox
            key={value}
            label={label}
            value={value}
            checked={selected.includes(value)}
            onChange={handleChange}
          />
        ))}
      </Items>
    </Container>
  );
};

Sidebar.propTypes = {
  onSelection: PropTypes.func.isRequired,
};

export default Sidebar;
